import React, { useState, useEffect } from "react";
import LcIconLink, { Size, Position } from "../../../components/Generic/LcIconLink";
import Layout from "../../../components/Layout/Layout";
import HHAttendantTable from "../../../components/Data/HHAttendantTable"
import moment from "moment";
import SideModal from "../../../components/Layout/SideModal/SideModal";
import AttendenceMoreResults from "../AttendenceMoreResults";
import DynamicTableGroupColumnManagerService, { Column, Group } from "../../../services/DynamicTableGroupAndColumnBuilder/DynamicTableGroupAndColumnBuilder"
import { useDispatch, useSelector } from "react-redux";
import { UserState } from "../../../store/reducers/userReducer";
import { MenuState } from "../../../store/reducers/menuReducer";
import { PrefState } from "../../../store/reducers/prefReducer";
import { RootState } from "../../../store/index";
import SolicitationAttendantService from "../../../services/SolicitationAttendantService/SolicitationAttendantService";
import TextTools from "../../../services/TextTools/TextTools";
import { SolicitationFilterV2 } from "../../../models/SolicitationFilter";
import { SolicitationView } from "../../../models/SolicitationView";
import AttendanceNewSolicitation from "../AttendanceNewSolicitation";
import AttendanceDragNDropComponent from "../AttendanceDragNDropComponent";
import { OptionsTooltips } from "../../../models/OptionsTooltips";
import SolicitationService from "../../../services/SolicitationService/SolicitationService";
import sanitizeHtml from "sanitize-html";
import SolicitationCommentService from "../../../services/SolicitationCommentService/SolicitationCommentService";
import ReactTooltip from "react-tooltip";
import { useDebounce } from "use-debounce";
import LcLoading from "../../../components/Generic/LcLoading";
import AlertNotification from "../../../components/Dialog/AlertNotification";
import LcInfiniteTable from "../../../components/Data/LcInfiniteTable";
import { SolicitationAttendantFilter } from "../../../models/SolicitationAttendantFilter";
import "./index.css";
import ToolTipHelper from "../../../components/Generic/ToolTipHelper";
import MenuOptionsHelper from "../../../components/Generic/MenuOptionsHelper";
import { Field } from "../../../models/Field";
import { Period } from "../../../models/Period";

const AttendanceList: React.FC = (props) => {
    const solicitationCommentService = new SolicitationCommentService(props);
    const user = useSelector<RootState, UserState>(state => state.user);
    const pref = useSelector<RootState, PrefState>(state => state.pref);
    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const dispatch = useDispatch();
    const [selectedRow, setSelectedRow] = useState<any>();
    const [isLoadingSolicitation, setIsLoadingSolicitation] = useState<boolean>(true);
    const [refresh, setRefresh] = useState(false);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [openNotificationError, setOpenNotificationError] = useState<boolean>(false);
    const [duplicateRow, setDuplicateRow] = useState<any>(undefined);
    const dateTimeNow = new Date();
    const [helperColumns, setHelperColumns] = useState<any[]>([]);
    const textTools = new TextTools();

    const functionRowClick = {
        rowPointer: true,
        rowFunction: setSelectedRow
    }

    const handleSelectRow = (row: any) => {
        setSelectedRow(row);
    }

    const rowHelper = [
        {
            idStatus: 7,
            workStatus: 7,
            urgency: 1,
            nameUserRequester: user.name,
            nameBusinessArea: "Processor",
            id: 123456,
            registrationDate: moment(new Date()).subtract(1, "days"),
            endDate: moment(new Date()).subtract(1, "days").add(3, "hours"),
            responseDate: moment(new Date()).subtract(1, "days").add(3, "hours").subtract(10, "minutes"),
            slaResponseDate: moment(new Date()).subtract(1, "days").add(9, "hours"),
            slaSolutionDate: moment(new Date()).subtract(1, "days").add(11, "hours"),
            attendant: "",
            subject: "teste assunto",
            workGroupName: "Central de Serviços Processor",
            slaPercentual: 32,
            sloPercentual: 29,
            nameResponsibleUser: "Julia Vargas"
        },
        {
            idStatus: 2,
            id: 123457,
            registrationDate: moment(new Date()).subtract(1, "days"),
            endDate: moment(new Date()).subtract(1, "days").add(3, "hours"),
            responseDate: moment(new Date()).subtract(1, "days").add(3, "hours").subtract(10, "minutes"),
            slaResponseDate: moment(new Date()).subtract(1, "days").add(9, "hours"),
            slaSolutionDate: moment(new Date()).subtract(1, "days").add(11, "hours"),
            attendant: "",
            subject: "teste assunto 2",
            workGroupName: "Central de Serviços Processor",
            slaPercentual: 32,
            sloPercentual: 29,
            nameResponsibleUser: "João Santos"
        }
    ];

    useEffect(() => {
        setSolicitationsTooltip((menu.showHelper) ? rowHelper : solicitations);
        setOpenFilters(false);
        setShowCreateSolicitation(false);
        setOpen(false);
    }, [menu.showHelper])

    const groupService = new DynamicTableGroupColumnManagerService();
    const solicitationAttendantService = new SolicitationAttendantService(props);
    const solicitationService = new SolicitationService(props)

    const [filterDefault, setFilterDefault] = useState<{ size: number, term: string, column: string, direction: string }>({ size: 20, term: "", column: "", direction: "asc" });
    const [filter, setFilter] = useState<{ size: number, term: string, column: string, direction: string }>(filterDefault);
    const [listaGruposKey, setListaGruposKey] = useState<{ key: string, content: any[] }[]>([]);
    const [selectedGroups, setSelectedGroups] = useState<Group>(groupService.openGroupDefault);
    const [optionColumns, setOptionColumns] = useState<Column>(groupService.optionColumnsDefault);
    const [open, setOpen] = useState<boolean>(false);
    const [optionsGroups, setOptionsGroups] = useState<any[]>([]);
    const [moreResultsList, setMoreResultsList] = useState<any[]>([]);
    const [moreResultsType, setMoreResultsType] = useState<string>("");
    const [solicitations, setSolicitations] = useState<SolicitationView[]>([]);
    const [solicitationsTooltip, setSolicitationsTooltip] = useState<any[]>([]);
    const [filteredSolicitations, setFilteredSolicitations] = useState<SolicitationView[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [columnsList, setColumnsList] = useState<any[]>([]);
    const [currentFilter, setCurrentFilter] = useState<any>();
    const [solicitationList, setSolicitationList] = useState<Period[]>([]);
    const [modalVincular, setModalVincular] = useState<boolean>(false);
    const [groupList, setGroupList] = useState<string[]>([]);
    const optionsSanitize = {
        allowedTags: [],
        allowedAttributes: {}
    }

    useEffect(() => {
        initLoad();
    }, [])

    const initLoad = () => {
        setOpenFilters(false);

        const columnsStorageList = pref.data?.columnsStorageList;
        const columnsStorageListSelected = pref.data?.columnsStorageListSelected;

        let columnsList_ = (columnsStorageListSelected && columnsStorageListSelected.length > 0)
            ? columnsStorageListSelected
            : ((!textTools.compareObjects(columnsStorageList, {}))
                ? groupService.getColumns(columnsStorageList)
                : groupService.getColumns(optionColumns));

        columnsList_.map(column => {
            column = groupService.getRenderCell(column);
        });

        setColumnsList(columnsList_);

        const columnsListHelper: any[] = groupService.getColumns(groupService.optionColumnsDefault);
        columnsListHelper.map(column => {
            column = groupService.getRenderCell(column);
        });

        setHelperColumns(columnsListHelper);
    }

    const getSolicitations = async (filter: any) => {
        setSolicitations([]);
        setSolicitationsTooltip([]);
        setFilteredSolicitations([]);

        await getSolicitationsSemLoading(filter);

        setTimeout(() => {
            getTemplates();
        }, 2500);
    }

    const getSolicitationsSemLoading = async (filter: any) => {
        setLoading(true);

        var solicitationArray = [];

        try {
            const solicitationResponse = await solicitationAttendantService.GetFilterMultiAdvancedV2(filter as SolicitationFilterV2);

            solicitationArray = solicitationResponse.data.map((solicitation, index) => {
                return { ...solicitation, rowId: index }
            });

            setFilteredSolicitations(solicitationArray);
            setSolicitations(solicitationArray);
            setSolicitationsTooltip(solicitationArray);
        }
        catch (error: any) {
            setFilteredSolicitations([]);
            setSolicitations([]);
            setSolicitationsTooltip([]);
            // handleClearFilters()
            setLoading(false);
            console.error(error);
        }

        setLoading(false);
    }

    const getFilterDefault = () => {
        return {
            userId: user.id,
            assunto: "0",
            customerId: "0",
            idTeam: "0",
            attendantId: "0",
            requesterId: "0",
            idStatus: ["102"],
            incidentId: "0",
            IdsGroupService: "0",
            IdsFilterField: "0",
            IdsService: "0",
            dataInicio: "0",
            dataFinal: "0",
            TipoData: "0",
            attendantType: "1",
            form: false
        }
    }

    const [openModalAttPref, setOpenModalAttPref] = useState<boolean>(false);

    useEffect(() => {
        setOpenModalAttPref(pref.dataLocal?.openModalAttPref ?? false);
    }, [pref.dataLocal?.openModalAttPref])

    useEffect(() => {
        initLoadGroupsStorageList();
    }, [solicitations]);

    const initLoadGroupsStorageList = () => {
        if (solicitations.length > 0) {
            // setMoreResultsType("");

            let groupsStorageList = pref.data?.groupsStorageList ?? [];

            if (groupsStorageList && groupsStorageList.length > 0) {
                let selectedGroups_ = { ...selectedGroups, ungrouped: false };

                groupsStorageList.map(item => {
                    selectedGroups_ = { ...selectedGroups_, [item]: true };
                });

                handleSelectionGroups(selectedGroups_);
            }

            const columnsStorageList = pref.data?.columnsStorageList ?? {};

            if (!textTools.compareObjects(columnsStorageList, {})) {
                handleOptionColumns(columnsStorageList);

                let selectedGroups_ = groupService.groupList;

                Object.keys(columnsStorageList).map((field) => {
                    let field_ = field as string;

                    if (columnsStorageList[field_] === false) {
                        selectedGroups_ = selectedGroups_.filter(x => x.value !== field_);
                    }
                });

                setOptionsGroups(selectedGroups_);
            }
            else {
                setOptionsGroups(groupService.groupList);
            }

            agrupamento(groupsStorageList);
        }
    }

    useEffect(() => {
        const groupsStorageList = pref.data?.groupsStorageList;

        if (!textTools.compareObjects(filter, filterDefault)) {
            setFilterDefault(filter)
            setLoading(true);
            if (groupsStorageList && groupsStorageList !== "[]") {

                let filtered: any[] = filteredSolicitations
                setFilteredSolicitations([])
                filtered = groupService.sortColumns(filtered, filter)
                setFilteredSolicitations(filtered)
            }
            else {
                setFilteredSolicitations([])
                setFilteredSolicitations(groupService.sortColumns(filteredSolicitations, filter));
            }
            setLoading(false);
        }
    }, [filter]);

    useEffect(() => {
        if ((selectedGroups.ungrouped &&
            (
                selectedGroups.id ||
                selectedGroups.idStatus ||
                selectedGroups.workStatus ||
                selectedGroups.sla_slo ||
                selectedGroups.subject ||
                selectedGroups.workName ||
                selectedGroups.workGroupName ||
                selectedGroups.nameResponsibleUser ||
                selectedGroups.nameUserRequester ||
                selectedGroups.registrationDate ||
                selectedGroups.nameCustomer ||
                selectedGroups.nameBusinessArea ||
                selectedGroups.nameClassification ||
                selectedGroups.statusIcon ||
                selectedGroups.endDate ||
                selectedGroups.nameClassificationGroup ||
                selectedGroups.nameServiceGroup ||
                selectedGroups.nameOpenMode ||
                selectedGroups.urgency ||
                selectedGroups.nameProcess ||
                selectedGroups.nameService ||
                selectedGroups.slaResponseDate ||
                selectedGroups.slaSolutionDate ||
                selectedGroups.workType ||
                selectedGroups.businessUnitDescription ||
                selectedGroups.slaDescription ||
                selectedGroups.workDateBegin ||
                selectedGroups.workDateEnd ||
                selectedGroups.workDateRegister
            ))) {
            handleUnGroupGroups();
        }
    }, [selectedGroups]);

    useEffect(() => {
        if (selectedGroups) {
            let count = 0;

            Object.values(selectedGroups).map((field) => {
                if (field === true) {
                    count++;
                }
            });

            if (count === 0) {
                setSelectedGroups({ ...selectedGroups, ungrouped: true });
            }
        }
    }, [selectedGroups]);

    const onSortChangeAttendant = (sortData: any) => {
        const { sort, size } = sortData;
        setFilter({ ...filter, column: sort.column, direction: sort.direction, size: size });
    };

    const propritiesForTootip = (rowId: Number): Array<any> => {
        var fields: {
            text: string,
            value?: string,
            subValue?: string,
            propText?: React.CSSProperties,
            propValue?: React.CSSProperties,
            propSubvalue?: React.CSSProperties
        }[] = [];

        const row = solicitationsTooltip.find(resp => resp.id === rowId);
        var remainingSLA = "";
        var remainingSLO = "";

        if (row) {
            //#region SLA
            var respon = (row.slaResponseDate) ? moment(row.slaResponseDate).format("DD/MM/YYYY HH:mm") : '';

            var dataSLAResponseANUumber = moment(row.responseDate).diff(moment(row.slaResponseDate));
            var dataSLAResponseAA = moment(row.slaResponseDate).from(moment(row.responseDate ?? new Date())).replace('há', '').replace('em', '');

            var labelSLAResponseAA =
                ((dataSLAResponseANUumber < 0) ? "vence em " : "esperado em ") +
                respon +
                ", " +
                ((dataSLAResponseANUumber < 0) ? "restam ainda " : "excedeu em ") +
                dataSLAResponseAA;

            remainingSLA = labelSLAResponseAA;

            let diasSla = `${row.slaPercentual}%  ${remainingSLA}`;
            //#endregion SLA

            //#region SLO
            var slacloseDate = moment(new Date());

            if (row.endDate) slacloseDate = moment(row.endDate);
            if (row.cancellationDate) slacloseDate = moment(row.cancellationDate);

            var dataSLACLOSEANUumber = moment(slacloseDate).diff(row.slaSolutionDate);
            var dataSLACLOSEAA = moment(row.slaSolutionDate).from(slacloseDate).replace('há', '').replace('em', '');

            var labelSLACLOSEA =
                ((dataSLACLOSEANUumber < 0) ? "vence em " : "esperado em ")
                + moment(row.slaSolutionDate).format("DD/MM/YYYY HH:mm")
                + ", "
                + ((dataSLACLOSEANUumber < 0) ? "restam ainda " : "excedeu em ")
                + dataSLACLOSEAA;

            remainingSLO = labelSLACLOSEA;

            let diasSlo = `${row.sloPercentual}%  ${remainingSLO}`;
            //#endregion SLO

            let trabalhoStatus = solicitationService.workStatus.find(x => x.id === row.workStatus);
            let statusValue = solicitationService.statusList.find(x => x.value === row.idStatus.toString());
            let urgency = solicitationService.urgency.find(x => x.id === row.urgency);

            const chamadoValue: React.CSSProperties = { fontSize: "14px", whiteSpace: "pre-line", fontWeight: "bold" };
            const sublabels: React.CSSProperties = { color: "#8B90A3", fontWeight: "bold", fontSize: "14px", };
            const statusCSS: React.CSSProperties = { fontWeight: "500", fontSize: "12px" };
            const workCss: React.CSSProperties = { fontWeight: "bold", fontSize: "12px", whiteSpace: "pre-line" };
            const solicitanteCss: React.CSSProperties = { fontWeight: "bold", fontSize: "12px", whiteSpace: "pre-line", marginBottom: "1px", wordBreak: "break-word" };
            const slaSloCss: React.CSSProperties = { color: "#8B90A3", fontWeight: "bold", fontSize: "14px", marginBottom: "-3px" };

            const dataDia = moment(row.registrationDate).format("DD/MM");
            const dataHora = moment(row.registrationDate).format("HH:mm");

            let chamado = { text: "Chamado", subValue: row.id.toString(), propSubvalue: chamadoValue };
            let data = { text: "Data e hora", value: dataDia + " às " + dataHora, propText: sublabels, propValue: workCss };
            let solicitante = { text: "Solicitante: ", value: row.nameUserRequester, propText: sublabels, propValue: solicitanteCss };
            let company = { text: "", value: `${row.nameBusinessArea} - ${row.workGroupName}`, propValue: workCss };
            let slaSlo = { text: "SLA / SLO", value: "", propText: slaSloCss };
            let slaSloResponse = { text: "Resposta:", subValue: diasSla, propsText: statusCSS, propSubvalue: workCss };
            let slaSloSolution = { text: "Solução:", subValue: diasSlo, propsText: statusCSS, propSubvalue: workCss };
            let status = { text: "Status", value: "", propText: sublabels };
            let statusWork = { text: "Trabalho", value: "", subValue: `${trabalhoStatus?.label}`, propText: statusCSS, propSubvalue: workCss }
            let statusChamado = { text: "Chamado", value: "", subValue: `${statusValue?.label}`, propText: statusCSS, propSubvalue: workCss }
            let statusUrgency = { text: "Prioridade", value: "", subValue: `${urgency?.label}`, propText: statusCSS, propSubvalue: workCss }

            fields = [chamado, solicitante, company, data, slaSlo, slaSloResponse, slaSloSolution, status, statusWork, statusChamado, statusUrgency];
        }

        return fields;
    }

    const searchExpandedFields = async (solicitationId: number, setExpandedFieldsTooltip: any) => {
        try {
            const response = await solicitationCommentService.getCommentsViewBySolicitation(solicitationId);
            let expandedFieldsTemp: { text: string, value: string }[] = [];

            response.data.map((comment: any) => {
                const commentLenght = comment.text.length;
                let commentText = sanitizeHtml(comment.text, optionsSanitize);

                if (commentLenght >= 300) commentText = commentText.substring(0, 300) + " (...)";

                let commentValue = moment(comment.commentDate).fromNow();
                commentValue = commentValue.charAt(0).toUpperCase() + commentValue.slice(1);
                let comentario = { text: commentText, value: commentValue };

                expandedFieldsTemp.push(comentario);
            })

            setExpandedFieldsTooltip(expandedFieldsTemp);
        }
        catch (error) {

        }
        // await solicitationCommentService.getCommentsViewBySolicitation(solicitationId)
        //     .then(response => {

        //         let expandedFieldsTemp: { text: string, value: string }[] = [];

        //         response.data.map((comment: any) => {
        //             const commentLenght = comment.text.length;
        //             let commentText = sanitizeHtml(comment.text, optionsSanitize);

        //             if (commentLenght >= 300) commentText = commentText.substring(0, 300) + " (...)";

        //             let commentValue = moment(comment.commentDate).fromNow();
        //             commentValue = commentValue.charAt(0).toUpperCase() + commentValue.slice(1);
        //             let comentario = { text: commentText, value: commentValue };

        //             expandedFieldsTemp.push(comentario);
        //         })

        //         setExpandedFieldsTooltip(expandedFieldsTemp);
        //     })
    }

    const optionsProprities: OptionsTooltips = {
        delayHide: 20,
        delayShow: 1000,
        delayUpdate: 500,
        noOpacity: true,
        expandNoResults: "Sem comentários disponíveis",
        position: "Right",
        expandPosition: "Right",
    }

    const proprities = {
        montaFields: propritiesForTootip,
        searchExpandedFields: searchExpandedFields,
        optionsProprities: optionsProprities
    }

    const optionsGroupBy = [
        {
            label: "Agrupar por",
            value: "groups",
            subMenu: optionsGroups
        },
        {
            label: "Colunas",
            value: "columns",
            subMenu: groupService.columnList
        },
        {
            label: "Densidades",
            value: "density",
            subMenu: groupService.densityList
        }
    ]

    const [openFilters, setOpenFilters] = useState<boolean>(false);
    const [search, setSearch] = useState<string>("");
    const [searchDebounce] = useDebounce(search, 2500);

    const handleOpenFilter = () => {
        setOpenFilters(false);
    }

    const clearSolicitationList = () => {
        // setSolicitationList([]);
        // setFilteredSolicitations(solicitations);
        setSolicitationsTooltip(solicitations);
    }

    const [messageErrorGroup, setMessageErrorGroup] = useState<string>("");

    const cleanMessageError = (selection?: any) => {
        setMessageErrorGroup("")
        selection && getSolicitations(currentFilter);
    }

    useEffect(() => {
        if (searchDebounce !== "") {
            getSolicitationsDebounce();
        }
        else {
            clearSolicitationList();
        }

    }, [searchDebounce])

    const getSolicitationsDebounce = async () => {
        setIsLoadingSolicitation(true);
        setMessageErrorGroup("");

        try {
            // setSolicitationList([]);
            let filterDefaultC = {
                ...getFilterDefault(),
                idStatus: ["111"],
                assunto: search,
                top: "25"
            };

            const solicitationResponse = await solicitationAttendantService.GetFilterMultiAdvancedV2(filterDefaultC as SolicitationFilterV2);
            let solicitationListB: Period[] = [];

            solicitationResponse.data.map((solicitationC: any) => {
                let solicitationItem_ = {
                    label: "> " + solicitationC.id + " - " + solicitationC.subject,
                    text: solicitationC.subject,
                    fields: [{
                        name: solicitationC.subject,
                        value: solicitationC.id.toString()
                    }],
                    record: solicitationC
                }

                if (solicitationListB.filter(c => c.label === solicitationItem_.label).length === 0) {
                    solicitationListB.push(solicitationItem_);
                }
            })

            setSolicitationList([...solicitationListB]);
        }
        catch (error: any) {
            console.warn(error);

            if (error.response.data.includes("Visualização não autorizada")) {
                setMessageErrorGroup(error.response.data);
            }
            else if (error.response.data.includes("Solicitação não encontrada")) {
                setMessageErrorGroup("Nenhum chamado foi não encontrado. Verifique a sua pesquisa e tente novamente");
            }
        }

        setIsLoadingSolicitation(false);
        setRefresh(false);
    }

    const getSearch = (search: string) => setSearch(search);

    const getSolicitationsMoreLines = async (text: string) => {
        setLoading(true);
        setFilteredSolicitations([]);
        try {
            let filterDefaultC = { ...getFilterDefault() } as SolicitationFilterV2;
            filterDefaultC = { ...filterDefaultC, idStatus: ["111"], assunto: text };
            const solicitationResponse = await solicitationAttendantService.GetFilterMultiAdvancedV2(filterDefaultC as SolicitationFilterV2);
            setFilteredSolicitations(solicitationResponse.data);
            setSolicitationsTooltip(solicitationResponse.data);
        }
        catch (error: any) {
            console.debug(error.response)

            if (error.response.data.includes("Visualização não autorizada")) {
                setMessageErrorGroup(error.response.data);
            }
        }

        setLoading(false);
    }

    const onChangeSelectionSolicitation = (selection: any, text: string) => {
        if (selection.fields[0].value === "mais" && text !== "") {
            getSolicitationsMoreLines(text);
        }
        else {
            setSelectedRow(selection.record);
        }
    }

    useEffect(() => {
        // filteredSolicitations.length > 0 ? setLoading(false) : setLoading(true)
        const idsVistos = {};
        const novaLista = filteredSolicitations.filter(item => {
            if (!idsVistos[item.id]) {
                idsVistos[item.id] = true;
                return true;
            }
            return false;
        });

        dispatch({ type: "PREF_ATTENDANT_SOLICITATIONLIST", payload: novaLista });
    }, [filteredSolicitations])

    const [showCreateSolicitation, setShowCreateSolicitation] = useState<boolean>(false);
    const [modalVisibleTemplates, setModalVisibleTemplates] = useState<boolean>(false);
    const [templateList, setTemplateList] = useState<any[]>([]);
    const [templateSelected, setTemplateSelected] = useState<any>(undefined);
    const [headerTemplates, setHeaderTemplates] = useState<string>("");
    const [loadingTemplate, setLoadingTemplate] = useState<boolean>(false);

    const onChageSelectionTemplate = (selected: any) => {
        setTemplateSelected(undefined)
        if (selected === "mais") {
            setModalVisibleTemplates(true);
            setHeaderTemplates("Templates de Chamados - Mais");
        }
        else if (selected === "editar") {
            setModalVisibleTemplates(true);
            setHeaderTemplates("Templates de Chamados - Editar");
        }
        else {
            setModalVisibleTemplates(false);
            setHeaderTemplates("");
            setTemplateSelected(selected);
            setShowCreateSolicitation(true);
        }
    }

    const testeList = [
        { label: "> 123456 - <strong>teste</strong> assunto - <strong>teste</strong> detalhes", },
        { label: "> 123457 - <strong>teste</strong> assunto 2 - detalhes", },
    ]

    const functionGeneric = [
        {
            title: "Novo chamado",
            icon: "ppi ppi-plus",
            tooltip: "Novo chamado",
            func: () => {
                setShowCreateSolicitation(true);
                setTemplateSelected(undefined);
            }
        },
        {
            title: "Novo chamado com template",
            icon: "ppi ppi-chevron-down-alt",
            tooltip: "Templates de chamado",
            size: "tiny" as Size,
            tooltipPosition: "fullRight" as Position,
            isSelection: true,
            selection: {
                contents: templateList,
                onChange: onChageSelectionTemplate
            }
        },
        {
            title: "Duplicar chamado",
            icon: "ppi ppi-duplicate",
            iconDisabled: {
                color: "#B5B7C6",
                tooltip: "Selecione um chamado para ser duplicado"
            },
            tooltip: "Duplicar chamado",
            func: () => {
                if (selectedRows.length > 1) {
                    setOpenNotificationError(true);
                }
                else {
                    setOpenNotificationError(false);
                    setDuplicateRow(selectedRows[0]);
                    setShowCreateSolicitation(true);
                }
            }
        },
        {
            title: "Vincular chamado",
            icon: "ppi ppi-flow-merge",
            tooltip: "Vincular chamado",
            isVincular: true,
            func: () => {
                setModalVincular(!modalVincular);
            }
        },
        {
            title: "",
            icon: "ppi ppi-divider-vertical",
            iconDisabled: {
                color: "#B5B7C6",
                tooltip: "",
                disabled: true
            },
            tooltip: "",
            func: () => {
            }
        },
        {
            title: "Mais filtros",
            icon: "ppi ppi-filter",
            tooltip: "Mais filtros",
            activedAfterClick: openFilters,
            func: () => {
                setOpenFilters(!openFilters);
            }
        },
        {
            title: "Pesquisar pelo número do chamado",
            icon: "ppi ppi-search",
            tooltip: "Pesquisar pelo número do chamado",
            isFilter: true,
            isFilterCampo: {
                isLoadingContents: isLoadingSolicitation,
                contents: (menu.showHelper) ? testeList : solicitationList,
                onChange: onChangeSelectionSolicitation,
                onChangePesquisa: getSearch,
                dropDownOptions: [],
                onClickOption: () => { }
            }
        },
        {
            title: "",
            icon: "ppi ppi-divider-vertical",
            iconDisabled: {
                color: "#B5B7C6",
                tooltip: "",
                disabled: true
            },
            tooltip: "",
            func: () => {
            }
        },
    ];

    const getTemplates = async () => {
        try {
            const solicitationResponse = await solicitationService.getTemplateAttendantSolicitations(Number(user.id));
            setTemplateList(solicitationResponse.data);
        }
        catch (error) {
            console.warn(error);
        }
    }

    const handleGroup = (group_: string) => {
        let groupList_: string[] = groupList;

        if (!groupList.includes(group_)) groupList_.push(group_);
        else groupList_ = groupList.filter(x => x !== group_);

        dispatch({ type: "PREF_UPDATE", payload: { name: "groupsStorageList", value: groupList_ } });

        agrupamento(groupList_);
    }

    const agrupamento = (groupList_: string[]) => {
        if (groupList_ != null && groupList_ !== undefined && groupList_.length > 0) {
            setGroupList(groupList_);

            const listaGruposKey_ = groupService.GroupListKey(groupList_, solicitations);
            setListaGruposKey(listaGruposKey_);

            let listaTemp = groupService.groupListAggregator(solicitations, listaGruposKey_);

            const filteredSolicitations_ = (listaTemp.length > 0 && groupList_.length === 0) ? listaTemp : listaTemp[0];
            setFilteredSolicitations(filteredSolicitations_);
        }
        else {
            setFilteredSolicitations(solicitations);
        }
    }

    const handleUnGroupGroups = () => {
        setFilteredSolicitations(solicitations);
        setGroupList([]);
        setSelectedGroups(groupService.openGroupDefault);

        const columnsStorageList = pref.data?.columnsStorageList;

        let columnsList_ = (columnsStorageList && !textTools.compareObjects(columnsStorageList, {}))
            ? groupService.getColumns(columnsStorageList)
            : groupService.getColumns(groupService.optionColumnsDefault);

        columnsList_.map(column => {
            column = groupService.getRenderCell(column);
        });

        setColumnsList(columnsList_);

        const params: string[] = ["groupsStorageList"];
        handleClear(params);
    }

    const handleClear = (params: string[]) => {
        let obj = {};

        if (params.includes("groupsStorageList")) {
            obj = { ...obj, "groupsStorageList": [] };
        }

        if (params.includes("columnsStorageListSelected")) {
            obj = { ...obj, "columnsStorageListSelected": [] };
        }

        if (params.includes("columnsStorageList")) {
            obj = { ...obj, "columnsStorageList": {} };
        }

        if (params.includes("groupVisible")) {
            obj = { ...obj, "groupVisible": undefined };
        }

        if (params.includes("expandCloseAll")) {
            obj = { ...obj, "expandCloseAll": undefined };
        }

        if (params.includes("densitySelected")) {
            obj = { ...obj, "densitySelected": "defaultdensity" };
        }

        dispatch({ type: "PREF_UPDATE_MORE", payload: obj });
    }

    const handleSelectionGroups = (selectedGroups_?: any) => {
        const todasPropriedadesFalse = Object.values(selectedGroups_).every(valor => valor === false);

        if (todasPropriedadesFalse) {
            selectedGroups_ = { ...selectedGroups_, ungrouped: true };

            const params: string[] = ["groupsStorageList"];
            handleClear(params);
            setGroupList([]);
        }

        setSelectedGroups(selectedGroups_ ?? groupService.openGroupDefault);
    }

    const handleOptionColumns = (optionColumns_: any) => {
        setOptionColumns(optionColumns_);
        dispatch({ type: "PREF_UPDATE", payload: { name: "columnsStorageList", value: optionColumns_ } });
    }

    const handleRedefine = () => {
        setOptionColumns(groupService.optionColumnsDefault);
        setSelectedGroups(groupService.openGroupDefault);
        setOptionsGroups(groupService.groupList);
        setFilteredSolicitations(solicitations);
        setGroupList([]);
        handleCloseModal();

        const columnsList_: any[] = groupService.getColumns(groupService.optionColumnsDefault);

        columnsList_.map(column => {
            column = groupService.getRenderCell(column);
        });

        setColumnsList(columnsList_);

        const params: string[] = ["groupsStorageList", "densitySelected", "groupVisible", "expandCloseAll", "columnsStorageList", "columnsStorageListSelected"];
        handleClear(params);
    }

    const [headerModal, setHeaderModal] = useState<string>("");

    const handleOpen = (type: string, lista: string[]) => {
        if (type === "groups") {
            setHeaderModal("Mais agrupamentos");
            setMoreResultsType("groups");
            setMoreResultsList(lista);
        }
        else if (type === "columns") {
            setHeaderModal("Mais colunas");
            setMoreResultsType("columns");

            const columnsListSemCheckbox = columnsList.filter(x => x.field !== "checkbox");
            setMoreResultsList(columnsListSemCheckbox);
        }

        setOpen(true);
    }

    const handleSelectColumns = (column: any) => {
        let column_: { label: string, value: string } = { label: "", value: "" }

        if (column.field) {
            column_ = {
                label: column.headerName,
                value: column.field
            }
        }
        else {
            column_ = {
                label: column.label,
                value: column.value
            }
        }

        const selectedColumn = optionsGroups.find(x => x.value.includes(column_.value));

        if (selectedColumn != null) {
            if (optionsGroups.includes(selectedColumn)) {
                let groupsList = optionsGroups.filter(x => x !== selectedColumn);
                setOptionsGroups(groupsList);
            }
        }
        else {
            let _optionsGroups = [
                ...optionsGroups,
                {
                    label: column_.label,
                    value: column_.value
                }
            ];

            const listaTemp = _optionsGroups.sort((a: any, b: any) => {
                return a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1;
            });

            setOptionsGroups(listaTemp);
        }
    }

    const handleCloseModal = async () => {
        setHeaderModal("");
        setMoreResultsList([]);
        setOpen(false);
        setSelectedRows([]);
        // setDuplicateRow(undefined);
        // setTemplateSelected(undefined);

        // const filterSelected = pref.data?.filterSelected;

        // if (filterSelected != null) {
        //     getSolicitations(filterSelected);
        // }
    }

    const handleClickItem = (item: any) => {
        if (moreResultsType === "groups") {
            if (selectedGroups.ungrouped == true && selectedGroups[item.value] == false) {
                const selectedGroups_ = { ...selectedGroups, [item.value]: true, ungrouped: false };
                handleSelectionGroups(selectedGroups_);
                handleGroup(item.value);
            }
            else if (item.value !== "ungrouped" && selectedGroups.ungrouped === false && selectedGroups[item.value] === false) {
                const selectedGroups_ = { ...selectedGroups, [item.value]: !selectedGroups[item.value] };
                handleSelectionGroups(selectedGroups_);
                handleGroup(item.value);
            }
            else if (item.value !== "ungrouped" && selectedGroups[item.value] === true) {
                const selectedGroups_ = { ...selectedGroups, [item.value]: !selectedGroups[item.value] };
                handleSelectionGroups(selectedGroups_);
                handleGroup(item.value);
            }
            else if (item.value === "ungrouped" && selectedGroups[item.value] === false) {
                handleUnGroupGroups();
            }
        }
        else if (moreResultsType === "columns") {
            const optionColumns_ = { ...optionColumns, [item.field]: !optionColumns[item.field] };
            handleSelectColumns(item);
            handleOptionColumns(optionColumns_);
        }
    }

    const getStatus = (row: any) => {
        if (optionColumns.urgency === true) {
            let urgency = solicitationService.urgency.find(x => x.id === row.urgency);

            return (urgency) ? urgency.color : "#FAFAFA";
        }
    }

    const handleClearFilters = () => {
        let _filter = { ...getFilterDefault() };

        dispatch({ type: "MENU_SELECTED_UPDATE", payload: selectionsList[0].fields });
        setCurrentFilter(_filter);
        // getSolicitations(filter);
        // setRefresh(!refresh);
    }

    const solicitationTypeFilter = (filter: any, solicitationTypeLocal: string) => {
        setOpenFilters(false);

        let dataInicial: string;
        let dateFinal: string;
        let dateSave: string = "";

        const filterMap: Record<string, () => void> = {
            active: () => {
                filter = { ...filter, idStatus: "2" };
            },
            today: () => {
                dataInicial = moment(dateTimeNow).format("YYYY-MM-DD");
                dateFinal = moment(dateTimeNow).add(1, "day").format("YYYY-MM-DD");
                dateSave = "today";
                filter = { ...filter, dataInicio: dataInicial, dataFinal: dateFinal, TipoData: "0" };
            },
            week: () => {
                dataInicial = moment(dateTimeNow).subtract(7, "days").format("YYYY-MM-DD");
                dateFinal = moment(dateTimeNow).add(1, "day").format("YYYY-MM-DD");
                dateSave = "week";
                filter = { ...filter, dataInicio: dataInicial, dataFinal: dateFinal, TipoData: "0" };
            },
            month: () => {
                const dateFirstDay = new Date(dateTimeNow.getFullYear(), dateTimeNow.getMonth(), 1);
                dataInicial = moment(dateFirstDay).format("YYYY-MM-DD");
                dateFinal = moment(dateTimeNow).add(1, "day").format("YYYY-MM-DD");
                dateSave = "month";
                filter = { ...filter, dataInicio: dataInicial, dataFinal: dateFinal, TipoData: "0" };
            },
            lastSixMonths: () => {
                dataInicial = moment(dateTimeNow).subtract(6, "months").format("YYYY-MM-DD");
                dateFinal = moment(dateTimeNow).format("YYYY-MM-DD");
                dateSave = "lastSixMonths";
                filter = { ...filter, dataInicio: dataInicial, dataFinal: dateFinal, TipoData: "0" };
            },
            lastTwelveMonths: () => {
                dataInicial = moment(dateTimeNow).subtract(12, "months").format("YYYY-MM-DD");
                dateFinal = moment(dateTimeNow).format("YYYY-MM-DD");
                dateSave = "lastTwelveMonths";
                filter = { ...filter, dataInicio: dataInicial, dataFinal: dateFinal, TipoData: "0" };
            },
            lastYear: () => {
                dataInicial = moment(dateTimeNow).subtract(1, "year").startOf("year").format("YYYY-MM-DD");
                dateFinal = moment(dateTimeNow).subtract(1, "year").endOf("year").format("YYYY-MM-DD");
                dateSave = "lastYear";
                filter = { ...filter, dataInicio: dataInicial, dataFinal: dateFinal, TipoData: "0" };
            },
            all: () => {
                filter = { ...filter, idStatus: ["102"] };
            },
            default: () => {
                filter = { ...filter, idStatus: solicitationTypeLocal };
            },
        };

        (filterMap[solicitationTypeLocal] || filterMap.default)();

        dispatch({ type: "PREF_UPDATE", payload: { name: "datefilterSelected", value: dateSave } });

        return filter;
    };

    const loadfilterSelected = () => {
        const filterSelected = pref.data?.filterSelected;

        let menuFilter_ = (filterSelected)
            ? filterSelected
            : { ...getFilterDefault() };

        var filter = (menu.selectedItem && user)
            ? menu.selectedItem[0].value
            : (filterSelected)
                ? filterSelected.idStatus
                : "all";

        menuFilter_ = solicitationTypeFilter(menuFilter_, filter);

        if (!menuFilter_.attendantType) menuFilter_.attendantType = "1";

        setCurrentFilter(menuFilter_);
        getSolicitations(menuFilter_);
    }

    useEffect(() => {
        loadfilterSelected();
    }, [menu.selectedItem,]);

    useEffect(() => {
        if (refresh) {
            loadfilterSelected();
            setRefresh(false);
        }
    }, [refresh]);

    useEffect(() => {
        const interval = setInterval(() => {
            if (currentFilter) getSolicitationsSemLoading(currentFilter);
        }, 180000);

        return () => clearInterval(interval);
    }, [currentFilter]);

    const selectionsList = [
        {
            label: "Solicitações ativas exceto concluídas",
            text: "Solicitações ativas exceto concluídas",
            default: (pref.data?.SolicitationListAtttedantType && pref.data?.SolicitationListAtttedantType.includes("102") || !pref.data?.SolicitationListAtttedantType),
            fields: [{ name: "102", value: ["102"] }]
        },
        {
            label: "Todas as situações",
            text: "Todas as situações",
            default: (pref.data?.SolicitationListAtttedantType && pref.data?.SolicitationListAtttedantType.includes("111")),
            fields: [{ name: "all", value: ["111"] }]
        },
        {
            label: "Situações ativas",
            text: "Situações ativas",
            default: (pref.data?.SolicitationListAtttedantType && pref.data?.SolicitationListAtttedantType.includes("100")),
            fields: [{ name: "100", value: ["100"] }]
        },
        {
            label: "Situações pausadas",
            text: "Situações pausadas",
            default: (pref.data?.SolicitationListAtttedantType && pref.data?.SolicitationListAtttedantType.includes("103")),
            fields: [{ name: "103", value: ["103"] }]
        },
        {
            label: "Situações inativas",
            text: "Situações inativas",
            default: (pref.data?.SolicitationListAtttedantType && pref.data?.SolicitationListAtttedantType.includes("101")),
            fields: [{ name: "101", value: ["101"] }]
        },
        {
            label: "Chamados em andamento",
            text: "Chamados em andamento",
            default: (pref.data?.SolicitationListAtttedantType && pref.data?.SolicitationListAtttedantType.includes("2")),
            fields: [{ name: "active", value: ["2"] }],
        },
        {
            label: "Chamados de hoje",
            text: "Chamados de hoje",
            default: (pref.data?.SolicitationListAtttedantType && pref.data?.SolicitationListAtttedantType === "today"),
            fields: [{ name: "today", value: "today" }]
        },
        {
            label: "Chamados da semana",
            text: "Chamados da semana",
            default: (pref.data?.SolicitationListAtttedantType && pref.data?.SolicitationListAtttedantType === "week"),
            fields: [{ name: "week", value: "week" }]
        },
        {
            label: "Chamados deste mês",
            text: "Chamados deste mês",
            default: (pref.data?.SolicitationListAtttedantType && pref.data?.SolicitationListAtttedantType === "month"),
            fields: [{ name: "month", value: "month" }]
        },
        {
            label: "Chamados dos últimos 6 meses",
            text: "Chamados dos últimos 6 meses",
            default: (pref.data?.SolicitationListAtttedantType && pref.data?.SolicitationListAtttedantType === "lastSixMonths"),
            fields: [{ name: "lastSixMonths", value: "lastSixMonths" }]
        },
        {
            label: "Chamados dos últimos 12 meses",
            text: "Chamados dos últimos 12 meses",
            default: (pref.data?.SolicitationListAtttedantType && pref.data?.SolicitationListAtttedantType === "lastTwelveMonths"),
            fields: [{ name: "lastTwelveMonths", value: "lastTwelveMonths" }]
        },
        {
            label: "Chamados do ano anterior",
            text: "Chamados do ano anterior",
            default: (pref.data?.SolicitationListAtttedantType && pref.data?.SolicitationListAtttedantType === "lastYear"),
            fields: [{ name: "lastYear", value: "lastYear" }]
        },
    ];

    const onChageSelection = (selected: any) => {
        dispatch({ type: "PREF_UPDATE", payload: { name: "SolicitationListAtttedantType", value: selected.fields[0].value } });
    }

    const solicitationSelection = {
        selections: selectionsList,
        // onChange: (p) => { sessionStorage.setItem("SolicitationListAtttedantType", p.fields[0].value) }
        onChange: onChageSelection
    }


    const handleChangeColumns = (itemList: any[]) => {
        const checkboxItem = groupService.getColumns(optionColumns).filter(x => x.field === "checkbox");
        setColumnsList([...checkboxItem, ...itemList]);

        dispatch({
            type: "PREF_UPDATE_MORE",
            payload: {
                "columnsStorageList": optionColumns,
                "columnsStorageListSelected": itemList
            }
        });
    }

    const handleClose = () => {
        getSolicitations(currentFilter);
        setShowCreateSolicitation(false);
        setTemplateSelected(undefined);
        setDuplicateRow(undefined);
    }

    const handleSelectedRows = (selectedRowsTable: any) => {
        setSelectedRows(selectedRowsTable);
    }

    const handleReload = () => {
        setMessageErrorGroup("");
        // getSolicitations(currentFilter);
        setRefresh(true);
    }

    const moreTemplateColumns = [
        {
            field: "",
            headerName: "Copiar",
            width: "15%",
            overflow: "visible",
            renderCell: (row: any) => (
                <LcIconLink
                    icon={"ppi ppi-document-duplicate"}
                    onClick={() => handleClickCopy(row)}
                    tooltip={"Criar nova solicitação com base no template"}
                    tooltipPosition={"fullRight"}
                />
            )
        },
        {
            field: "detail",
            headerName: "Descrição",
            width: "85%",
        },
    ];

    const editTemplateColumns = [
        {
            field: "",
            headerName: "Copiar",
            width: "12%",
            overFlow: "visible",
            renderCell: (row: any) => (
                <LcIconLink
                    icon={"ppi ppi-document-duplicate"}
                    onClick={() => handleClickCopy(row)}
                    tooltip={"Criar nova solicitação com base no template"}
                    tooltipPosition={"fullRight"}
                />
            )
        },
        {
            field: "detail",
            headerName: "Descrição",
            width: "65%",
            renderCell: (row: any) => (
                <p>{row.nameTemplate}</p>
            )
        },
        {
            field: "",
            headerName: "Excluir",
            width: "20%",
            align: "right",
            overflow: "visible",
            renderCell: (row: any) => (
                <LcIconLink
                    icon={"ppi ppi-trash"}
                    tooltip={"Excluir template"}
                    onClick={() => handleClickDelete(row)}
                />
            )
        },
    ];

    const handleFilters = (filterTemp: any) => {
        let newFilter = { ...getFilterDefault(), ...filterTemp };
        dispatch({ type: "PREF_UPDATE", payload: { name: "filterSelected", value: newFilter } });
        setCurrentFilter(newFilter);
        getSolicitations(newFilter);
    }

    const handleClickCopy = (row: any) => {
        setModalVisibleTemplates(false);
        setHeaderTemplates("");
        setTemplateSelected(row);
        setShowCreateSolicitation(true);
    }

    const handleClickDelete = async (row: any) => {
        setLoadingTemplate(true);

        try {
            await solicitationService.deleteTemplateAttendantSolicitation(Number(user.id), row.id);
            getTemplates();
        }
        catch (error) {
            console.warn(error);
        }

        setLoadingTemplate(false);
    }

    useEffect(() => {
        if (menu.showHelper) {
            const openFiltersAttPref = pref.dataLocal?.openFiltersAttPref ?? false;

            if (openFiltersAttPref) {
                setOpenFilters(true);
            }
            else {
                setOpenFilters(false);
            }
        }
    }, [pref.dataLocal?.openFiltersAttPref]);

    return (
        <Layout selection={solicitationSelection}>
            <div onScrollCapture={() => ReactTooltip.hide()}>
                {
                    !selectedRow &&
                    <>
                        {
                            pref.dataLocal?.openTooltipAttPref == true &&
                            <ToolTipHelper visible={pref.dataLocal?.openTooltipAttPref ?? false} />
                        }

                        {
                            pref.dataLocal?.openMenuOptionsAttPref == true &&
                            <MenuOptionsHelper />
                        }
                        <HHAttendantTable
                            loading={loading}
                            status={getStatus}
                            columns={(menu.showHelper) ? helperColumns : columnsList}
                            rows={(menu.showHelper) ? rowHelper : filteredSolicitations}
                            defaultRows={solicitations}
                            size={solicitations.length}
                            onSortChange={onSortChangeAttendant}
                            functionGeneric={functionGeneric}
                            optionsGroupBy={optionsGroupBy}
                            handleGroup={handleGroup}
                            grouperList={(menu.showHelper) ? [] : listaGruposKey}
                            handleOpen={handleOpen}
                            optionsGroups={optionsGroups}
                            handleSelectColumns={handleSelectColumns}
                            handleSelectionGroups={handleSelectionGroups}
                            selectedGroups={selectedGroups}
                            handleOptionColumns={handleOptionColumns}
                            optionColumns={optionColumns}
                            handleRedefine={handleRedefine}
                            openFilters={openFilters}
                            openModalVincular={modalVincular}
                            handleClearFilters={handleClearFilters}
                            handleOpenFilter={handleOpenFilter}
                            rowClick={functionRowClick}
                            handleSelectRow={handleSelectRow}
                            currentFilter={currentFilter}
                            tootipPropeties={proprities}
                            handleSelectedRows={handleSelectedRows}
                            handleReload={handleReload}
                            messageErrorGroup={messageErrorGroup}
                            cleanMessageError={cleanMessageError}
                            handleClear={handleClear}
                            handleFilters={handleFilters}
                            filterDefault={getFilterDefault()}
                        />
                    </>
                }
            </div>

            <SideModal
                header={headerModal}
                visible={open}
                onClose={() => handleCloseModal()}
                fixedHeader={true}
            >
                {
                    moreResultsType === "groups"
                        ? <AttendenceMoreResults
                            list={moreResultsList}
                            handleClickItem={handleClickItem}
                            selectedGroups={selectedGroups}
                        />
                        : <AttendanceDragNDropComponent
                            open={open}
                            list={moreResultsList}
                            handleClickItem={handleClickItem}
                            optionColumns={optionColumns}
                            handleChangeColumns={handleChangeColumns}
                            handleCloseModal={handleCloseModal}
                        />
                }
            </SideModal>

            <SideModal
                header={headerTemplates}
                visible={modalVisibleTemplates}
                onClose={() => setModalVisibleTemplates(false)}
            >
                <LcLoading loading={loadingTemplate} label={"Carregando..."}>
                    <LcInfiniteTable
                        height={"calc(100% - 250px)"}
                        loading={loadingTemplate}
                        columns={(headerTemplates === "Templates de Chamados - Mais") ? moreTemplateColumns : editTemplateColumns}
                        rows={templateList}
                        size={templateList.length}
                        linked={false}
                    />
                </LcLoading>
            </SideModal>

            <AttendanceNewSolicitation
                show={showCreateSolicitation || openModalAttPref}
                duplicateRow={duplicateRow}
                templateSelected={templateSelected}
                handleClose={handleClose}
            />

            <AlertNotification
                open={openNotificationError}
                severity={"warning"}
                message={"Selecione somente um chamado para duplicar"}
                handleClose={() => setOpenNotificationError(!openNotificationError)}
                minHeight={""}
            />
        </Layout>
    );
};

export default AttendanceList;